import { filtersMethods } from '@process-advisor/process-miner/api/methods/filters/index';
import { analyticsMethods } from '@process-advisor/process-miner/api/methods/analytics/index';
import { navigationMethods } from '@process-advisor/process-miner/api/methods/navigation/index';
import { settingsMethods } from '@process-advisor/process-miner/api/methods/settings/index';
import { slicersMethods } from '@process-advisor/process-miner/api/methods/slicers/index';
import { sharedMethods } from '@process-advisor/process-miner/api/methods/shared/index';
import { processMinerMethods } from '@process-advisor/process-miner/api/methods/processMinerMethods';
import { modalsMethods } from '@process-advisor/process-miner/api/methods/modals/index';
import { eventlogMethods } from '@process-advisor/process-miner/api/methods/eventlog/index';
import { modelMethods } from '@process-advisor/process-miner/api/methods/model/index';
import { dataMethods } from '@process-advisor/process-miner/api/methods/data/index';
import { decompositionTreeMethods } from '@process-advisor/process-miner/api/methods/decompositionTree/index';
import { clusterMethods } from '@process-advisor/process-miner/api/methods/cluster/index'
import { influencerMethods } from '@process-advisor/process-miner/api/methods/influencer/index';
import { lifeCycleMethods } from '@process-advisor/process-miner/api/methods/lifecycle/index';
import { histogramMethods } from '@process-advisor/process-miner/api/methods/histogram/index'
import { discoveryRuleMethods } from '@process-advisor/process-miner/api/methods/discoveryRules/index'
import { findingMethods } from '@process-advisor/process-miner/api/methods/findings/index'
import { timeMethods } from '@process-advisor/process-miner/api/methods/time/index'

export const methods = {
    ...filtersMethods,
    ...navigationMethods,
    ...settingsMethods,
    ...slicersMethods,
    ...sharedMethods,
    ...processMinerMethods,
    ...analyticsMethods,
    ...modalsMethods,
    ...eventlogMethods,
    ...modelMethods,
    ...dataMethods,
    ...decompositionTreeMethods,
    ...clusterMethods,
    ...influencerMethods,
    ...lifeCycleMethods,
    ...histogramMethods,
    ...discoveryRuleMethods,
    ...findingMethods,
    ...timeMethods,
};
